import React from 'react';
import '../Styles/Footer.css';
import { FaFacebookF, FaLinkedinIn, FaTwitter, FaInstagram } from 'react-icons/fa';

function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="row gy-4">
          <div className="col-md-6 col-lg-3">
            <h5 className="footer-title">Iqube Technologies</h5>
            <p>Empowering innovation with scalable and smart technology solutions.</p>
          </div>
          <div className="col-md-6 col-lg-3">
            <h6>Quick Links</h6>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#clients">Clients</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3">
            <h6>Contact</h6>
            <ul className="footer-contact">
              <li>Email: hr@iqubeinc.com</li>
              {/* <li>Phone: +91-98765-43210</li> */}
              <li>15 Corporate Pl S,Suite 138, Piscataway, NJ 08854</li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3">
            <h6>Follow Us</h6>
            <div className="footer-social">
              <a href="/"><FaFacebookF /></a>
              <a href="/https://www.linkedin.com/company/iqube-technologies-inc"><FaLinkedinIn /></a>
              <a href="/"><FaTwitter /></a>
              <a href="/"><FaInstagram /></a>
            </div>
          </div>
        </div>

        <div className="footer-bottom text-center mt-4">
          <p>© {new Date().getFullYear()} Iqube Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
